export default initHeroBanner;

/**
 * javascript class for jQuery selector
 */
const CLASSELEM = {
    breadcrumbs: '.js-plp-breadcrumbs',
    herobanner_breadcrumbsPlaceholder: '.js-herobanner-breadcrumbPlaceholder',
};

function initHeroBanner() {
    const $breadcrumbs = $(CLASSELEM.breadcrumbs);
    if ($breadcrumbs.length > 0) {
        searchContentSlotHeroBanner($breadcrumbs);
    }
}

function searchContentSlotHeroBanner($breadcrumbs) {
    const $bcPlaceholder = $(CLASSELEM.herobanner_breadcrumbsPlaceholder);
    if ($bcPlaceholder.length > 0) {
        moveBreadcrumbs($breadcrumbs, $bcPlaceholder);
    } else {
        $breadcrumbs.removeClass('d-none');
    }
}

function moveBreadcrumbs($breadcrumbs, $bcPlaceholder) {
    $bcPlaceholder.empty().html($breadcrumbs);
    $breadcrumbs.removeClass('d-none');
}
